export const GDS_ENDPOINT_KEY = 'gds'
